// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SettingFilledSvg from "@fishx/icons-svg/es/asn/SettingFilled";
import FishxIcon from '../components/FishxIcon';

var SettingFilled = function SettingFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SettingFilledSvg
  }));
};

SettingFilled.displayName = 'SettingFilled';
export default React.forwardRef(SettingFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SettingFilled.js
// module id = 4090
// module chunks = 0